import { ck, URLS } from "fire-wind-water";
import SETTURL from "../assets/conf/setting.json";
import { resetURL } from "../../stempcore/src/sbase";

ck.json = true;

let tenantId,
  webinarId,
  preview,
  customFormId,
  linkId,
  urlForm,
  configId,
  sconfigId,
  instanceId,
  weChatId,
  markCode,
  markType,
  tc,
  isOverPrivew,
  isSetting,
  sourceKey,
  trackId,
  needVerify,
  isRefuse,
  qrCode,
  contactId,
  returnUrl;
export function init() {
  tenantId = URLS.getURL("tenantId");
  webinarId = URLS.getURL("webinarId");
  preview = parseInt(URLS.getURL("preview") || URLS.getHash("preview"));
  customFormId = URLS.getURL("customFormId") || URLS.getHash("customFormId");
  linkId = URLS.getURL("linkId") || URLS.getHash("linkId") || "";
  isOverPrivew =
    URLS.getURL("isOverPrivew") || URLS.getHash("isOverPrivew") || "";
  urlForm = URLS.getURL("urlForm") || URLS.getHash("urlForm"); //页面来源
  configId = URLS.getURL("configId") || URLS.getHash("configId");
  sconfigId = URLS.getURL("sconfigId") || URLS.getHash("sconfigId");
  instanceId = URLS.getURL("instanceId") || URLS.getHash("instanceId");
  weChatId = parseInt(URLS.getURL("weChatId") || URLS.getHash("weChatId"));
  markCode = URLS.getURL("markCode") || URLS.getHash("markCode");
  markType = URLS.getURL("markType") || URLS.getHash("markType");
  tc = URLS.getURL("tc") || URLS.getHash("tc");
  isSetting = URLS.getURL("isSetting");
  sourceKey = URLS.getURL("sourceKey") || URLS.getHash("sourceKey");
  trackId = URLS.getURL("trackId");
  needVerify = URLS.getURL("needVerify") || URLS.getHash("needVerify");
  isRefuse = URLS.getURL("isRefuse") || URLS.getHash("isRefuse");
  qrCode = URLS.getURL("qrCode") || URLS.getHash("qrCode");
  contactId = URLS.getURL("contactId") || URLS.getHash("contactId");
  returnUrl = URLS.getURL("returnUrl") || URLS.getHash("returnUrl");
  resetURL(SETTURL);
  if (returnUrl) {
    returnUrl = decodeURIComponent(returnUrl);
    try {
      returnUrl = window.atob(returnUrl);
    } catch (e) {
      console.log(e);
    }
  }
}
init();

export function fixUrl(content) {
  if (window.location.href.indexOf("local") > -1) {
    return true;
  } else if (window.location.href.indexOf(content.formalUrl) < 0) {
    const hash =
      content.formalUrlLocation.split("#").length > 0
        ? "#" + content.formalUrlLocation.split("#")[1]
        : "";
    const hashParams = hash.indexOf("?") > -1 ? "?" + hash.split("?")[1] : "";
    const url1 =
      content.formalUrlAndUsePage + window.location.search + hash + hashParams;
    window.location.href = url1;
    return false;
  }
  return true;
}

export {
  tenantId,
  webinarId,
  preview,
  customFormId,
  linkId,
  returnUrl,
  urlForm,
  configId,
  instanceId,
  weChatId,
  markCode,
  markType,
  tc,
  sconfigId,
  isOverPrivew,
  isSetting,
  sourceKey,
  trackId,
  needVerify,
  isRefuse,
  qrCode,
  contactId,
};
